export const PAYMENTS = 'payments';
export const TASKS = 'tasks';
export const EXTENDED = 'extended';
